import _ from 'lodash'
import { SearchTree } from '../constants/ProConstants';

const scan = (node, path = [], result = [])=>{
    let obj = null
    if(!node.children.length){
        obj = {id: node.id, key:node.key, code: `${node.id}`, type:node.type, name:node.label, parentId:node.parentId, active: node.active}
        result.push(path.concat(node.type === 'BED'? {...obj, assignmentId:_.has(node.data, "assignments")?(_.isEmpty(GetLatestAssignment(node.data.assignments))?null :GetLatestAssignment(node.data.assignments).assignmentId) : null}:obj));
    }        
    for(const child of node.children){
        obj = {id: node.id, code: `${node.id}`, key:node.key, type:node.type, name:node.label, parentId:node.parentId, active:node.active}
        scan(child, path.concat(node.type === 'BED'? {...obj, assignmentId:_.has(node.data, "assignments")?(_.isEmpty(GetLatestAssignment(node.data.assignments))?null :GetLatestAssignment(node.data.assignments).assignmentId) : null}:obj), result);
    }
   
    return result;
} 
export const GetBuildings = (treeData)=>{
    const treeArray = _.get(treeData, "children")?_.uniqBy(scan(treeData).flat(), 'key') : [];   
    return  _.filter(treeArray, (t)=> {return _.upperCase(t.type) === 'BUILDING'})     
   
}

export const GetLatestAssignment = (assignments)=>{
    return _.find(assignments, function(o) { return o.latestAssignment; })   
}

export const GetAllParents= (tree, node, parents = [])=>{  
    let parent = SearchTree(tree, "key", node.parentId);
    if(parent){
        parents.push({id: parent.id, code: `${parent.id}`, key:parent.key, type:parent.type, name:parent.label, parentId:parent.parentId, active:parent.active});
        if(!_.isEqual(parent.type === "LOCATION"))          
            GetAllParents(tree, parent, parents)
    }     
 
   return parents;

}

export const GetTreeNode = (tree, key)=>{
    let treeNode = SearchTree(tree, "key", key);
    if(treeNode){
        return {id: treeNode.id, code: `${treeNode.id}`, key:treeNode.key, type:treeNode.type, name:treeNode.label, parentId:treeNode.parentId, active:treeNode.active}
    }
}

export const ExpandAll = (tree, result = {})=>{
    if(_.has(tree , "children") && _.get(tree.children, "length")> 0){      
        result = _.isEmpty(result)? {"key": tree.key, [tree["key"]]:true} : {...result, [tree["key"]]:true }
        _.forEach(tree.children, (child)=>{
           result = {...result, ...ExpandAll(child, result)}
        })
       
    }
    return result;
}
